import React, { Fragment, useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Card from '../../../../components/Card/Card';
import FlowsList from '../../components/Flow/FlowsList';
import Pagination from '../../../../components/Pagination/Pagination';
import DialogModal from '../../../../modals/DialogModal/DialogModal';
import FlowListFilters from '../../components/Flow/FlowListFilters';
import Layout from '../../../../components/Layout/Layout';
import { FMessage } from '../../../../hoc/IntlComponents';

const View = ({
  data: { loading, page, search, sortOrder, sortBy, title, flows, pageCount, startSetStreams, showModal },
  handleSearch,
  updateLocation,
  changePage,
  handleFlowRemove,
  handleSort,
  toggleModal,
  removeFlow,
  findFilters
}) => {
  const [offerFilters, saveOffersFilters] = useState({});
  const [query, getQuery] = useState('');

  const handleApplyBtn = () => {
    updateLocation({ title: query });
    startSetStreams({ ...offerFilters, title: query });
  };

  return (
    <Layout formattedTitle="pages.flows.title">
      <Layout.Col md="12">
        <Card
          titleLG
          className="streams-list card-loading-silent flow-filters-card"
          title="flows.header.title"
          defaultMessage="Flows"
        >
          <Card.Body>
            <Row>
              <Col xl='4' className='flows-page-helper-text'>
                <h3>
                  <FMessage id='flows.header.title.theme_4' />
                </h3>
                <p>
                  <FMessage id='flows.helper.text' />
                </p>
              </Col>
              <Col xl='6' lg='8' className='filters-col'>
                <FlowListFilters
                  withLabels
                  onSearch={handleSearch}
                  query={title}
                  onChange={startSetStreams}
                  updateLocation={updateLocation}
                  saveOffersFilters={saveOffersFilters}
                  getQuery={getQuery}
                  notApplyOnChange
                />
                <Button className='flow-filter-apply-btn' onClick={handleApplyBtn}>
                  <FMessage id='main.choose' />
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card
          loading={loading}
        >
          {/* <Card.Body>
            <FlowListFilters
              onSearch={handleSearch}
              query={title}
              onChange={startSetStreams}
              updateLocation={updateLocation}
            />
            {!loading && !search && pageCount > 1 && (
              <Pagination
                pageCount={pageCount}
                activePage={page + 1}
                onPageChange={changePage}
                scrollToAfterPageChanged={{ ref: null }}
              />
            )}
          </Card.Body> */}

          <Card.Body className="no-padding">
            {search && flows.length === 0 ? (
              <div className="card-empty">
                <FormattedMessage id="flows.not-found" defaultMessage="No flows found" />
              </div>
            ) : (
                <Fragment>
                  {!loading ? (
                    flows.length > 0 ? (
                      <FlowsList
                        theme={4}
                        flows={flows}
                        onFlowRemove={handleFlowRemove}
                        sortOrder={sortOrder}
                        sortBy={sortBy}
                        handleSort={handleSort}
                      />
                    ) : (
                        <div className="card-empty">
                          <FormattedMessage id="flows.no-flows" defaultMessage="No flows" />
                        </div>
                      )
                  ) : null}
                </Fragment>
              )}
          </Card.Body>

          {!loading && !search && pageCount > 1 && (
            <Card.Footer>
              <Pagination
                pageCount={pageCount}
                activePage={page + 1}
                onPageChange={changePage}
                scrollToAfterPageChanged={{ ref: null }}
              />
            </Card.Footer>
          )}
        </Card>
      </Layout.Col>

      <FormattedMessage
        id="flows.modal.message"
        defaultMessage="Would you like to remove this flow?"
      >
        {message => (
          <DialogModal
            open={showModal}
            message={message}
            onCancel={toggleModal}
            onConfirm={removeFlow}
          />
        )}
      </FormattedMessage>
    </Layout>
  );
};

export default View;
